module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Itallic-6b56812e6b0b961568df889ed2ac4152.svg";